import { createHttpLink } from '@apollo/client/core';
import { getRepositoryName, getGraphQLEndpoint, getRepositoryEndpoint, createClient } from '@prismicio/client';

const createPrismicLink = (config) => {
  const {
    repositoryName: providedRepositoryName,
    fetch,
    accessToken,
    apiEndpoint: providedApiEndpoint,
    uri: providedURI,
    ...options
  } = config;
  let repositoryName = providedRepositoryName;
  if (!repositoryName && providedURI) {
    repositoryName = getRepositoryName(providedURI);
  }
  if (!repositoryName) {
    throw new Error("At least one of the following options are required for createPrismicLink(): repositoryName, uri. If a repositoryName option is not given, the uri option must be a standard, non-proxied Prismic GraphQL API URL including the repository name.");
  }
  const uri = providedURI || getGraphQLEndpoint(repositoryName);
  const apiEndpoint = providedApiEndpoint || getRepositoryEndpoint(repositoryName);
  const client = createClient(apiEndpoint, {
    fetch,
    accessToken
  });
  return createHttpLink({
    uri,
    fetch: client.graphQLFetch,
    useGETForQueries: true,
    ...options
  });
};

const PrismicLink = createPrismicLink;

export { PrismicLink, createPrismicLink };
//# sourceMappingURL=index.js.map
